import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PdfParserMain from "./PdfParserMain";
import UploadTemplate from "./UploadTemplate";
import TemplateList from "./TemplateList";
import GeneratePdf from "./GeneratePdf";
import GenerationHistory from "./GenerationHistory";
import FontManager from "./FontManager";

const PdfParserRoutes = () => {
    return (
        <Routes>
            <Route element={<PdfParserMain />}>
                {/* Default route - Upload */}
                <Route index element={<UploadTemplate />} />
                <Route path="upload" element={<UploadTemplate />} />
                
                {/* Templates list */}
                <Route path="templates" element={<TemplateList />} />
                
                {/* Generate PDFs */}
                <Route path="generate" element={<GeneratePdf />} />
                
                {/* Generation History */}
                <Route path="history" element={<GenerationHistory />} />
                
                {/* Font Manager */}
                <Route path="fonts" element={<FontManager />} />
                
                {/* Catch all - redirect to upload */}
                <Route path="*" element={<Navigate to="/pdf-parser" replace />} />
            </Route>
        </Routes>
    );
};

export default PdfParserRoutes;
